import StandardModal from "js/components/shared/StandardModal";
import SupportDetails from "js/components/SupportDetails";
import useStore from "stores/index";
import { getSupportContactDetails } from "stores/classwizeConfigStore";
import React, { FC } from "react";

interface Props {
	open: boolean;
	okay: () => void;
}

export const DistrictSupportWindow: FC<Props> = ({ open, okay }) => {
	const contactDetails = useStore((state) => getSupportContactDetails(state));

	return (
		<StandardModal title="In-school support details" open={open} close={okay}>
			{contactDetails ? (
				<>
					<div>{contactDetails.support_message}</div>
					<br />
					<SupportDetails />
				</>
			) : (
				<div>It looks like your administrator hasn&apos;t configured an in-school support contact for Classwize.</div>
			)}
		</StandardModal>
	);
};
